<button
  mat-button
  type="button"
  class="btn_secondary_text"
  [attr.aria-label]="ariaLabel || null"
  [ngClass]="{
    'btn_secondary_text--warning': color === 'warning',
    'btn_secondary_text_icon-right': !iconPosition,
    'btn_secondary_text_icon-left': iconPosition
  }"
  [disabled]="disabled"
  [disableRipple]="true"
  (click)="onClick()"
>
  <mat-icon [class]="iconClass" *ngIf="icon && typeIcon">{{ icon }}</mat-icon>
  {{ label }}
</button>
